export const enum ProfileMatchingStatus {
  Success = 'success',
  Failed = 'failed'
}

export interface Entry extends Record<PropertyKey, unknown> {
  id: string
  last_name: string
  first_name: string
  birth_date: string
  member_id?: string | null
  group_number?: string | null
  origin?: string | null
  email?: string | null
  user_agent: string
  ip: string
  created_at: string
  status: ProfileMatchingStatus
}

export type QueryKey = [
  'profile-matching',
  SearchParams
]

export interface QueryData {
  data: Entry[]
  total: number
  count: number
}

export interface State {
  searchParams: SearchParams
}

export type Action =
  | { type: 'query/set', payload: string }
  | { type: 'filters/set', payload: SearchParams['filters'] }
  | { type: 'filters/merge', payload: Partial<SearchParams['filters']> }
  | { type: 'filters/clear' }
  | { type: 'sort/set', payload: Sort }
  | { type: 'pagination/page/set', payload: number }
  | { type: 'pagination/page-size/set', payload: number }

export interface SearchParams {
  query: string

  filters: {
    status: ProfileMatchingStatus[]
    origin: string[]
  }

  sort: Sort
  pagination: Pagination
}

export const sortKeys = [
  'created_at',
  'last_name',
  'birth_date',
  'email',
  'user_agent',
  'ip',
  'status'
] as const

export type SortKey = typeof sortKeys[number]
export type SortDirection = 'asc' | 'desc'

interface Sort {
  field: SortKey
  direction: SortDirection
}

interface Pagination {
  page: number
  pageSize: number
}
